import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Star, ArrowRight } from "lucide-react";
import { Seo } from "../components/Layout";
import TestimonialCard, { Stars } from "../components/TestimonialCard";
import BookingButton from "../components/BookingButton";
import { TESTIMONIALS, AVERAGE_RATING, REVIEW_COUNT } from "../data/testimonials";

export default function Temoignages() {
  useEffect(() => { document.title = "Témoignages | Parfaits Imparfaits"; }, []);

  return (
    <>
      <Seo
        title="Témoignages"
        description={`${REVIEW_COUNT} avis 5★ Google : retours d'expérience sur les séances d'hypnose régressive et spirituelle de Valentine DL.`}
        canonical="https://www.parfaitsimparfaits.fr/temoignages"
      />

      {/* Schema.org Review aggregation for SEO stars */}
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            name: "Parfaits Imparfaits — Valentine DL",
            url: "https://www.parfaitsimparfaits.fr",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: AVERAGE_RATING,
              bestRating: 5,
              worstRating: 1,
              reviewCount: REVIEW_COUNT,
            },
            review: TESTIMONIALS.map((t) => ({
              "@type": "Review",
              author: { "@type": "Person", name: t.name },
              reviewRating: { "@type": "Rating", ratingValue: t.rating, bestRating: 5 },
              reviewBody: t.text,
            })),
          }),
        }}
      />

      <section className="pt-40 pb-12" data-testid="testimonials-hero">
        <div className="max-w-5xl mx-auto px-6 lg:px-10">
          <p className="eyebrow mb-5">Vos retours</p>
          <h1 className="text-5xl sm:text-6xl font-serif font-light leading-tight text-sand-900">
            Témoignages
          </h1>
          <div className="mt-8 flex flex-wrap items-center gap-5">
            <Stars count={5} className="!gap-1" />
            <p className="text-lg text-sand-700">
              <strong className="text-sand-900 font-medium">{AVERAGE_RATING.toFixed(1)} / 5</strong> · {REVIEW_COUNT} avis vérifiés sur Google
            </p>
          </div>
          <p className="mt-6 text-sand-700 max-w-2xl leading-relaxed">
            Voici quelques retours partagés par celles et ceux qui m'ont fait
            confiance pour explorer leur monde intérieur. Chaque chemin est
            unique, et je vous remercie d'avoir permis à ces rencontres
            d'exister.
          </p>
        </div>
      </section>

      <section className="py-12 pb-32" data-testid="testimonials-grid">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {TESTIMONIALS.map((t, i) => (
              <TestimonialCard
                key={i}
                {...t}
                testid={`testimonial-${i}`}
              />
            ))}
          </div>

          <div className="mt-20 text-center bg-sand-200/40 rounded-2xl p-12 border border-sand-300/60">
            <h2 className="text-3xl font-serif font-light text-sand-900">
              Et si c'était à votre tour ?
            </h2>
            <p className="mt-4 text-sand-700 max-w-2xl mx-auto">
              Réservez une première séance et laissez-vous porter par votre propre voyage intérieur.
            </p>
            <div className="mt-8 flex justify-center flex-wrap gap-3">
              <BookingButton testid="testimonials-cta-rdv">Réserver une séance</BookingButton>
              <Link to="/contact" data-testid="testimonials-cta-contact" className="btn-outline">
                Poser une question <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
